import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';
import { FC } from 'react';
import Icon from 'src/common/components/Icon';
import UniversalLink from 'src/common/components/UniversalLink';
import { PATHS } from 'src/common/constants';
import getClassNames from 'src/common/utils/getClassNames';
import { NoListingState } from 'src/admin/listing-editor/providers/ListingsPageProvider';
import styles from './NoListing.module.scss';

export type NoListingProps = {
  state: NoListingState;
  hasPayoutMethod: boolean;
};
const NoListing: FC<NoListingProps> = ({ state, hasPayoutMethod }) => {
  const [t] = useTranslation('admin-listings');
  return (
    <div className={styles.root}>
      {state === 'search' && (
        <>
          <Icon id="common/binoculars" className={styles.icon} />
          <p className={styles.title}>{t('landing-page--no-listing-title')}</p>
        </>
      )}
      {/* When payment method is not setup */}
      {state === 'add' && !hasPayoutMethod && (
        <>
          <Icon id="common/plus-circle-fill" className={getClassNames(styles, 'icon', classNames('add', { hasPayoutMethod }))} />
          <p className={styles.title}>{t('landing-page--add-listing-title')}</p>
          <p className={styles.subtitle}>
            <Trans
              t={t}
              i18nKey="landing-page--add-listing-subtitle"
              components={[
                <UniversalLink
                  className={styles.paymentLink}
                  href={PATHS.ADMIN_PAYMENTS}
                />,
              ]}
            />
          </p>
        </>
      )}
      {/* When payment method is setup */}
      {state === 'add' && hasPayoutMethod && (
        <UniversalLink
          href={PATHS.ADMIN_LISTING_NEW}
          className={styles.addListingLink}
        >
          <Icon id="common/plus-circle-fill" className={getClassNames(styles, 'icon', classNames('add', { hasPayoutMethod }))} />
          <p className={styles.title}>{t('landing-page--add-listing-title')}</p>
          <p className={styles.subtitle}>
            {t('landing-page--add-listing-with-payout-subtitle')}
          </p>
        </UniversalLink>
      )}
    </div>
  );
};

export default NoListing;
